module.exports = __webpack_public_path__ + "static/Transition an existing team-35daf388fe8d61973e461d7affadbbe9.svg";